import { useBunja } from 'bunja/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { useOverlayItem } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { createStepComponent } from '@flipster/react/misc/step/Steps';

import { editProfileActionBunja, editProfileBunja } from './bunja';
import EditProfileForm from './edit-profile-form';
import PublicAgreement from './public-agreement';

type EditProfileModel = {
  form: undefined;
  public: { secondaryLabel: string; onSecondary: () => void };
};
const Steps = createStepComponent<EditProfileModel>();

// see below if you want to know all cases of this modal
// https://prextech.slack.com/archives/C087CLN6AKD/p1739432159557139
const EditProfileModal = () => {
  const { onClose } = useOverlayItem();
  const { steps, payloadAtom } = useBunja(editProfileBunja);
  const current = useAtomValue(steps.currentStepAtom);
  const back = useSetAtom(steps.backAtom);
  const { saveProfile, changeBothVisibilityToPublic, mutateProfile } = useBunja(editProfileActionBunja);
  const payload = useAtomValue(payloadAtom);

  return (
    <Modal>
      <Steps model={current}>
        <Steps.Step step='form'>
          {() => (
            <EditProfileForm onClose={onClose} onSubmit={saveProfile} setBothToPublic={changeBothVisibilityToPublic} />
          )}
        </Steps.Step>
        <Steps.Step step='public'>
          {({ secondaryLabel, onSecondary }) => (
            <PublicAgreement
              onClose={back}
              onPrimary={async () => {
                try {
                  await mutateProfile(payload);
                } catch {
                  // Do nothing
                }
              }}
              onSecondary={onSecondary}
              secondaryLabel={secondaryLabel}
            />
          )}
        </Steps.Step>
      </Steps>
    </Modal>
  );
};

export default EditProfileModal;
